module.exports = "https://static.wmbcdn.com/uniweb/images/1ebf2fe9298c8be4e1c6e12e3d58cfce.svg";